<template lang="pug">
study-result-detail-list.study-result-detail(
  :userRole='userRole',
  :currentLink='currentLink',
  :sideMenuLinkEvent='sideMenuLinkEvent',
  :logoutEvent='logoutEvent',
  :breadcrumbs='breadcrumbs',
  :breadcrumbMoveEvent='breadcrumbMoveEvent',
  :titleText='titleText',
  :studyResultDetailScore='studyResultDetailScore',
  :studyResultDetails='studyResultDetails',
  :studyAdviceMessage='studyAdviceMessage'
)
  template(#sideMenuSeparateText) 設定
  template(#logoutText) サインアウト
  template(#totalScoreHeader) 合計
  template(#knowledgeScoreHeader) 知識・技能
  template(#thinkingScoreHeader) 思考・判断・表現
  template(#scoreLabel) 得点
  template(#averageLabel) 平均点
  template(#problemNumberHeader) 大問番号
  template(#questionNumberHeader) 小問番号
  template(#correctSymbolHeader) 正誤
  template(#correctRateHeader) 正解率
  template(#studyAdviceTitle) 今回の結果について
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'
import StudentsApi from '@/mixins/api/StudentsApi'
import StudyResultDetailsApi from '@/mixins/api/StudyResultDetailsApi'
import StudyResultDetailList from '@/components/templates/manager/history/StudyResultDetailList.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { StudyResultDetailType, StudyResultDetailScore } from '@/models/studyResultDetailModel'
import { LinkSetting, SideMenuSettings } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { StudyResultUtils } from '@/utils/StudyResultUtils'
import { StudentManagementUtils } from '@/utils/StudentManagementUtils'

/**
 * 履歴管理・詳細画面（講師・先生）
 */
@Component({
  components: {
    StudyResultDetailList,
  },
})
export default class StudyResultDetail extends Mixins(LoginMethods, StudentsApi, StudyResultDetailsApi) {
  // テスト詳細ID
  private get studyId(): number {
    return Number(this.$route.params.studyId)
  }

  // 生徒ID
  private get studentId(): number {
    return Number(this.$route.params.studentId)
  }

  // 紙テスト結果ID
  private get paperTestId(): number {
    return Number(this.$route.params.paperTestId)
  }

  // パンくず
  private breadcrumbs: breadcrumbType[] = [
    {
      label: '履歴管理',
      location: { name: 'BranchHistoryStudyResultManagement' },
    },
    {
      label: '生徒を選ぶ',
      location: { name: 'BranchHistoryStudyResultStudentSelect', params: { studyId: String(this.studyId) } },
    },
    {
      label: 'さんの成績',
      location: {
        name: 'BranchHistoryStudyResultSummary',
        params: { studyId: String(this.studyId), studentId: String(this.studentId) },
      },
    },
    {
      label: 'テスト結果',
    },
  ]

  // 教室長・講師権限
  private userRole: UserRoles = UserRoles.BRANCH

  // サイドメニューの現在リンク
  private currentLink: LinkSetting = SideMenuSettings.MANAGER_HISTORY

  // タブに表示するタイトル
  private titleText = ''

  // テスト結果詳細得点情報
  private studyResultDetailScore: StudyResultDetailScore | null = null

  // テスト結果詳細表示情報
  private studyResultDetails: StudyResultDetailType[] = []

  // 学習アドバイスメッセージ
  private studyAdviceMessage = ''

  // 初期表示処理
  private async mounted() {
    // 表示情報を取得
    // API呼び出し
    this.$loading.start()
    // 結果詳細情報を取得
    const apiResponse = await this.getStudyResultDetails(this.studentId, this.paperTestId, this.userRole)
    this.titleText = StudyResultUtils.getStudyResultDetailTitle(apiResponse)
    this.studyResultDetailScore = StudyResultUtils.buildStudyResultDetailScore(apiResponse)
    this.studyResultDetails = StudyResultUtils.buildStudyResultDetails(apiResponse)
    this.studyAdviceMessage = StudyResultUtils.getAdviceMessage(apiResponse)
    // 生徒名を取得
    const apiResponseStudent = await this.getStudentData(this.studentId, this.userRole)
    this.breadcrumbs[2].label =
      StudentManagementUtils.getStudentUserName(apiResponseStudent) + this.breadcrumbs[2].label
    this.$loading.complete()
  }

  // サイドメニュー遷移イベント
  private sideMenuLinkEvent(link: LinkSetting) {
    // 設定されたリンク先ページへ遷移
    this.$router.push({ name: `Branch${link.name}` })
  }

  // ログアウトイベント
  private logoutEvent() {
    this.logout()
    // ログインページへ遷移
    this.$router.push({ name: 'BranchLogin' })
  }

  // パンくず遷移イベント
  private breadcrumbMoveEvent(breadcrumb: breadcrumbType) {
    if (breadcrumb.location) {
      this.$router.push(breadcrumb.location)
    }
  }
}
</script>
